import React, { SVGProps } from 'react';

export const ListEndStreamlineSVG = (props: SVGProps<SVGSVGElement>) => (
  <svg {...props} width='14' height='14' viewBox='0 0 14 14' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <path d='M7.91667 6.55859H1.6875' stroke='#252F3F' strokeLinecap='round' strokeLinejoin='round' />
    <path d='M7.91667 3.68359H1.6875' stroke='#252F3F' strokeLinecap='round' strokeLinejoin='round' />
    <path d='M5.04167 9.43359H1.6875' stroke='#252F3F' strokeLinecap='round' strokeLinejoin='round' />
    <path
      d='M10.3124 3.68359V8.47526C10.3124 8.72943 10.2115 8.97318 10.0317 9.1529C9.85201 9.33263 9.60825 9.43359 9.35409 9.43359H6.95825'
      stroke='#252F3F'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path
      d='M7.91658 8.47461L6.95825 9.43294L7.91658 10.3913'
      stroke='#252F3F'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
  </svg>
);
